import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  NgForm
} from '@angular/forms';
import { EvsProductService } from '../../../../../common/services/EvsProduct.service';
import { Router } from '@angular/router';

import { Location } from "@angular/common";
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { ConfirmationService } from 'primeng/primeng';
import { ToastrService } from 'ngx-toastr';
import { UploadService } from '../../../../../common/services/Upload.service';
import { PointOfSaleService } from './services/point_of_sale.service';
import _ from 'lodash';
import { IOption } from 'ng-select';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;
var that: any;

@Component({
  moduleId: module.id,
  selector: 'evs_product_setting',
  templateUrl: './product_setting.component.html',
  styleUrls: ['../product.css'],
  providers: [ConfirmationService, EvsProductService, PointOfSaleService],
})
@Injectable()
export class EvsProductSettingComponent implements OnInit, OnDestroy {
  @Input('idDetail') idDetail: any;
  @Output('backToList') backToList = new EventEmitter();
  @ViewChild('modalPointOfSale') modalPointOfSale;
  listItem = [];
  listECommerce = [];
  modalRef: BsModalRef;

  langSubscription: Subscription;
  currentLang: string = 'vi';
  placeholders: any = {};


  constructor(
    public productService: EvsProductService,
    public router: Router,
    private toastr: ToastrService,
    public upload: UploadService,
    public pointOfSaleService: PointOfSaleService,
    private _location: Location,
    private translate: TranslateService
  ) {
    that = this;
  }
  public model: any = {}
  backToComponent() {
    this.backToList.emit({
      isBack: true,
    });
  }
  // Nhận event từ màn add product-store
  back(event) {
    if (event['isBack'] == true) {
      this.isAdd = false;
    }
    this.loadDataProductStore(this.idDetail)
  }

  ngOnInit() {
    this.currentLang = this.translate.currentLang || 'vi';
    this.updatePlaceholders();
    this.langSubscription = this.translate.onLangChange.subscribe((event: any) => {
      this.currentLang = event.lang;
      this.updatePlaceholders();
    });

    // $('#status').select2({
    //   placeholder: "-- Trạng thái  111111--",
    //   allowClear: true,
    //   minimumResultsForSearch: Infinity
    // });
    $('#statusStoreName').select2({
      placeholder: this.placeholders.statusStoreName || "-- Chọn trạng thái --",
      allowClear: true,
      minimumResultsForSearch: Infinity
    });

    const query = {
      page: 0,
      pageSize: 100,
    }
    console.log(1111, this.idDetail)
    this.productService.getListProduct(this.idDetail, query).subscribe((res) => {
      if (res.code === 1) {
        // this.listECommerce = res.data.items;
        const arr = [];
        res.data.items.map((val, index) => {
          const item = {
            form: {
              id: val.id,
              image: val.image,
              name: val.name,
              link: val.link,
              listedPrice: val.listPrice,
              promotionalPrice: val.promotionPrice,
              status: val.status === 1,
            },
            messageError: {
              image: {
                text: '',
                state: false
              },
              name: {
                text: '',
                state: false
              },
              link: {
                text: '',
                state: false
              },
              // listedPrice: {
              //   text: '',
              //   state: false
              // },
            },
          }
          if (val.ecommerceId !== null) {
            item.form['ecommerceId'] = val.ecommerceId
          }
          arr.push(item)
          setTimeout(() => {
            this.appendImageToShow(val.image, index);
          }, 300)
        })
        this.listItem = arr
      }
      console.log('res', res)
      console.log('res', res.code)
    })

    this.productService.getListECommerce().subscribe((res) => {
      if (res.code === 1) {
        this.listECommerce = res.data.items;
      }
      console.log('res2', res)

    })
  }

  updatePlaceholders() {
    this.translate.get([
      'PS_CHON_TRANG_THAI',
      'PE_AN',
      'PE_HIEN_THI',
      'PS_CHON_FILE_UPLOAD'
    ]).subscribe((t: any) => {
      this.placeholders = {
        statusStoreName: t['PS_CHON_TRANG_THAI'],
        titleFile: t['PS_CHON_FILE_UPLOAD']
      };
      this.list_status_filter = [
        { value: this.product_hide.toString(), label: t['PE_AN'] },
        { value: this.product_show.toString(), label: t['PE_HIEN_THI'] },
      ];
      if (!this.files || this.files.length === 0) {
        this.titleFile = this.placeholders.titleFile;
      }
      $('#statusStoreName').select2({
        placeholder: this.placeholders.statusStoreName || "-- Chọn trạng thái --",
        allowClear: true,
        minimumResultsForSearch: Infinity
      });
    });
  }

  addNew(data?) {
    const index = this.listItem.length
    const item = {
      form: {
        image: (data && data.avatar) ? data.avatar : '',
        name: (data && data.name) ? data.name : '',
        link: '',
        listedPrice: '',
        promotionalPrice: '',
        status: false,
      },
      messageError: {
        image: {
          text: '',
          state: false
        },
        name: {
          text: '',
          state: false
        },
        link: {
          text: '',
          state: false
        },
        // listedPrice: {
        //   text: '',
        //   state: false
        // },
      },
    }
    if (data) {
      item.form['ecommerceId'] = data.id
    }
    this.listItem.push(item)

    if (data) {
      console.log(data.avatar, index)
      setTimeout(() => {
        this.appendImageToShow(data.avatar, index);
      }, 300)
    }
  }

  changeImage(index) {
    if (!this.listItem[index].form.image) {
      this.listItem[index].messageError.image.text = this.translate.instant('PS_ANH_KHONG_DUOC_TRONG');
      this.listItem[index].messageError.image.state = false;
    } else {
      this.listItem[index].messageError.image.text = ''
      this.listItem[index].messageError.image.state = true
    }
  }

  changeName(index) {
    console.log('this.listItem[index].form.name', this.listItem[index].form.name)
    if (!this.listItem[index].form.name) {
      this.listItem[index].messageError.name.text = this.translate.instant('PS_TEN_KHONG_DUOC_TRONG');
      this.listItem[index].messageError.name.state = false;
    } else {
      this.listItem[index].messageError.name.text = ''
      this.listItem[index].messageError.name.state = true
    }
  }

  changeLink(index) {
    if (!this.listItem[index].form.link) {
      this.listItem[index].messageError.link.text = this.translate.instant('PS_LINK_KHONG_DUOC_TRONG');
      this.listItem[index].messageError.link.state = false;
    } else {
      this.listItem[index].messageError.link.text = ''
      this.listItem[index].messageError.link.state = true
    }
  }

  changeListedPrice(index) {
    if (!(this.listItem[index].form.listedPrice || this.listItem[index].form.listedPrice === 0)) {
      this.listItem[index].messageError.listedPrice.text = this.translate.instant('PS_GIA_KHONG_DUOC_TRONG');
      this.listItem[index].messageError.listedPrice.state = false;
    } else {
      this.listItem[index].messageError.listedPrice.text = ''
      this.listItem[index].messageError.listedPrice.state = true
    }
  }

  checkForm() {
    let check = true;
    this.listItem.map((res, index) => {
      this.changeImage(index);
      this.changeName(index);
      this.changeLink(index);
      // this.changeListedPrice(index);
      const checkForm = _.findKey(res.messageError, ['state', false]);
      if (checkForm !== undefined) {
        check = false
      }
    })
    return check
  }

  save() {
    if (this.checkForm()) {
      console.log('this.listItem', this.listItem)
      // return;
      const listData = [];
      this.listItem.map((res) => {
        const item = {
          image: res.form.image.trim(),
          name: res.form.name.trim(),
          link: res.form.link.trim(),
          listPrice: res.form.listedPrice || res.form.listedPrice === 0 ? Number(res.form.listedPrice) : null,
          promotionPrice: res.form.promotionalPrice || res.form.promotionalPrice === 0 ? Number(res.form.promotionalPrice) : null,
          status: res.form.status === false ? 0 : 1,
        }
        if (res.form.ecommerceId) {
          item['ecommerceConfigId'] = res.form.ecommerceId
        }
        if (res.form.id) {
          item['id'] = res.form.id
        }
        listData.push(item)
      })
      this.productService.createdProduct(this.idDetail, listData).subscribe((res) => {
        if (res.code === 1) {

          this.toastr.success(this.translate.instant('PS_CAP_NHAT_CH_THANH_CONG'), '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.backToList.emit({
            isBack: false,
          });
        } else {
          this.toastr.error(this.translate.instant('PS_CAP_NHAT_CH_THAT_BAI'), res.message, {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      })

    }
  }

  removeElement(i) {
    this.listItem = this.listItem.filter((res, k) => {
      return i !== k;
    })
  }

  /*Ham them anh vao mang*/
  tusUpload = (item, i) => {
    for (const image of item.target.files) {

      const fileData = new FormData();
      // @ts-ignore
      fileData.append('file', image);
      return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
        const res = JSON.parse(response._body)
        if (res.status === 200) {
          const image2 = {
            id: res.data.fileId,
            url: res.data.url,
          };
          this.listItem[i].form.image = image2.url
          this.changeImage(i)
          this.appendImageToShow(image2.url, i);
        }
      });
    }
  };
  // img: any = [];
  // ckeContent = [];
  listIndexImage: any = [];
  currentNumberImage: any = 0;

  // public images: any[] = [];

  ramdomID() {
    return Math.floor(Math.random() * 100);
  }

  appendImageToShow(src, i) {
    let id = this.ramdomID();
    if (this.listIndexImage.indexOf(id) !== -1) {
      id = this.ramdomID();
    }
    this.currentNumberImage++;
    const listProductImage = `.listProductImage${i}`;
    const addNewImage = `.add-new-image${i}`;
    $(addNewImage).css('display', 'none');
    $(listProductImage).append(
      `<div id="` +
      'image' + i +
      id +
      `" style="float: left; position: relative;width: 60px; height: 60px;margin: 0;" class="qr-item-image">
          <img id="` +
      'itemImg' +
      id +
      `" src="` +
      src +
      `" alt="" />
          <i id="` +
      `closeImg${i}` +
      id +
      `" class="icon wb-close" style="position: absolute; top: 5px; right: 5px; cursor: pointer;"></i>
          </div>`
    );
    this.listIndexImage.push(id);
    const closeImg = `#closeImg${i}`
    $(closeImg + id.toString()).click(function (res) {
      const index = parseInt(
        res.currentTarget.id.toString().split(`closeImg${i}`)[1]
      );
      for (let k = 0; k < that.listIndexImage.length; k++) {
        if (that.listIndexImage[k] == index) {
          const imagek = `#image${i}`
          $(imagek + index.toString()).remove();
          that.listItem[i].form.image = ''
          that.changeImage(i)
          $(addNewImage).css('display', 'block');
          console.log(that.listIndexImage, k)
          that.listIndexImage.splice(k, 1);
          that.img.splice(k, 1);
          that.currentNumberImage--;
        }
      }
    });
  }
  showModalPoin() {
    this.modalPointOfSale.showModal()
  }
  /* End Ham them anh vao mang*/

  // Cấu hình sản phẩm cho cửa hàng
  activeTab = 1;
  isAdd: Boolean = false;
  public listDataProductStore = [];
  public pager: any;
  public pageIndex: number = 1;
  public page_size: number = 10;
  public total_product_store_point: number;
  public current_filter: any = {};
  public product_hide = 0;
  public product_show = 1;
  list_status_filter: Array<IOption> = [
    // { value: this.batch_not_pay.toString(), label: 'Chưa Thanh Toán' },
    { value: this.product_hide.toString(), label: 'Ẩn' },
    { value: this.product_show.toString(), label: 'Hiện thị' },
  ];
  public tab: number;
  changeTab(event) {
    if (event === 2) {
      this.tab == event;
      $('#statusStoreName').select2({
        placeholder: this.placeholders.statusStoreName || "-- Chọn trạng thái --",
        allowClear: true,
        minimumResultsForSearch: Infinity
      });
      console.log("tab", 2);
      this.loadDataProductStore(this.idDetail);
    } else {
      this.isAdd = false;
      console.log("tab", 1);
    }
  }
  addProductStore() {
    this.isAdd = true;
  }

  onSubmit() {
    let modelQuery = <any>{};
    let status = $('#statusStoreName').val();
    if (this.model.name) {
      modelQuery.storeName = this.model.name;
    }
    if (status) {
      modelQuery.status = Number(status);
    }
    this.current_filter = modelQuery
    console.log("modelQuery", modelQuery);
    this.loadDataProductStore(this.idDetail, modelQuery)
  }


  loadDataProductStore(productId, request: any = {}) {
    if (_.isEmpty(request)) {
      request = this.current_filter
    }
    this.listDataProductStore = [];
    request.page = this.pageIndex;
    request.pageSize = this.page_size
    this.pointOfSaleService.getList(productId, request).subscribe((res) => {
      if (res.code === 1) {
        this.listDataProductStore = res.data.items;
        this.total_product_store_point = res.data.pagination.totalElements;
      }
    }, (err) => {
      let mess = err.messages;
      this.toastr.warning(mess, this.translate.instant('PS_THONG_BAO') + ':', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    });
  }

  resetForm(frm: NgForm) {
    frm.reset();
    $('#statusStoreName').val("").trigger("change");
    this.onSubmit();
  }


  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      this.loadDataProductStore(this.idDetail);
    }
  }

  lastPageList() {
    this.pageIndex = this.pageIndex + 1;
    this.loadDataProductStore(this.idDetail);
  }

  inputPageList(event) {

    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      console.log("input", this.pageIndex, this.total_product_store_point);

      // this.loading_left = true;
      this.loadDataProductStore(this.idDetail);
    }
  }

  changeStatusProductStore(event, productStoreId) {
    const status = event.target.checked;

    let body = [{
      status: status === true ? 1 : 0,
      productStoreId: productStoreId
    }]
    setTimeout(() => {
      this.pointOfSaleService.updateStoreSale(body).subscribe((res) => {
        if (res.code === 1) {
          this.loadDataProductStore(this.idDetail);
          return this.toastr.success(this.translate.instant('PS_CAP_NHAT_TT_THANH_CONG'), this.translate.instant('PS_THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          return this.toastr.error(this.translate.instant('PS_CAP_NHAT_TT_THAT_BAI'), this.translate.instant('PS_THONG_BAO'), {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        }
      }, (error) => {
        return this.toastr.error(error.message, this.translate.instant('PS_THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      });
    }, 500)

  }

  removeProductStore(productStoreId?: any) {
    this.pointOfSaleService.deleteSoreSale(productStoreId).subscribe((res) => {
      if (res.code === 1) {
        this.loadDataProductStore(this.idDetail);
        return this.toastr.success(this.translate.instant('PS_XOA_THANH_CONG'), this.translate.instant('PS_THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      } else {
        return this.toastr.error(this.translate.instant('PS_XOA_THAT_BAI'), this.translate.instant('PS_THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    }, (error) => {
      return this.toastr.error(error.message, this.translate.instant('PS_THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    })

  }

  // End cấu hình sản phẩm cho điểm bán

  // import điểm bán
  @ViewChild('importProductStoreSale') importProductStoreSale: ModalDirective;
  public titleFile: string = '';
  public files: any = null;
  public message: { class: string, content: string } = null;


  openProductStoreSaleExcel() {
    this.importProductStoreSale.show();
  }

  closeProductStoreSaleExcel() {
    this.importProductStoreSale.hide();
    this.message = null;
    // this.clearInputFile();
  }
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
  clearInputFile() {
    var input = $("#controlFile");
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }
  onChange(event) {
    console.log(3345);

    console.log('event', event)
    this.files = event.target.files;
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = this.placeholders.titleFile || this.translate.instant('PS_CHON_FILE_UPLOAD');
    }
  }

  submitFormImportExcel() {
    this.message = null;
    this.titleFile = this.placeholders.titleFile || this.translate.instant('PS_CHON_FILE_UPLOAD');
    console.log('this.files ', this.files)
    console.log("ud", this.idDetail);
    if (this.files !== null && this.files.length > 0) {
      var file = this.files[0];
      this.files = null;
      var file_name = file.name;
      var allowedExtensions = ["xlsx", "xls", "csv"];
      var fileExtension = file_name.split('.').pop();
      console.log('allowedExtensions', allowedExtensions)
      console.log('fileExtension', fileExtension)
      if (this.isInArray(allowedExtensions, fileExtension)) {
        //msg process
        this.message = {
          class: "alert dark alert-success",
          content: this.translate.instant('PS_DANG_THUC_HIEN')
        };
        //upload file
        this.pointOfSaleService.uploadFileProduct(this.idDetail, file).subscribe((res: any) => {
          if (res.code === 1) {
            this.message = {
              class: "alert dark alert-icon alert-success",
              content: this.translate.instant('PS_IMPORT_SP_THANH_CONG'),
            };
            setTimeout(() => {
              this.pageIndex = 1;
              this.loadDataProductStore(this.idDetail);
            }, 1000);
          } else {
            this.message = {
              class: "alert dark alert-icon alert-danger",
              content: res.message
            }
              ;
          }
        }, error => {
          this.message = {
            class: "alert dark alert-icon alert-danger",
            content: error.message
          };
        });
        this.clearInputFile()
      } else {
        this.message = {
          class: "alert alert-danger",
          content: this.translate.instant('PS_VUI_LONG_CHON_DUNG_FILE')
        };
      }
    } else {
      this.message = {
        class: "alert alert-danger",
        content: this.translate.instant('PS_CHUA_CHON_FILE')
      };
    }

  }

  reloadList($event) {
    this.loadDataProductStore(this.idDetail);
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product-setting/product_setting.component.ts